import type { IProductReview } from 'src/types/product';

import { Typography } from '@mui/material';

import { ProductReviewItem } from './product-review-item';

// ----------------------------------------------------------------------

type Props = {
  reviews: IProductReview[];
};

export function ProductReviewList({ reviews }: Props) {
  return (
    <>
      {reviews && reviews.length === 0 && (
        <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center' }}>
          Yorum bulunamadı
        </Typography>
      )}
      {reviews.map((review, index) => (
        <ProductReviewItem key={index} review={review} />
      ))}
    </>
  );
}
